// Token initializer for JWT tokens
// This script is included in the page and initializes the JWT token on page load

import { initializeJwtToken, JWT_DEBUG, debugLog } from '../modules/jwtTokenManager.js';
import { maybeCaptureGeoObservation } from '../modules/geo-observation.js';

// Initialize JWT token on page load
document.addEventListener('DOMContentLoaded', async () => {
  debugLog('[JWT] Token initializer script started');
  try {
    // Only initialize if user is logged in (check for user-id meta tag)
    const userIdMeta = document.querySelector('meta[name="user-id"]');
    if (userIdMeta && userIdMeta.getAttribute('content')) {
      const userId = userIdMeta.getAttribute('content');
      debugLog('[JWT] User is logged in with ID:', userId);
      debugLog('[JWT] Starting token initialization process');

      const tokenData = await initializeJwtToken();

      if (tokenData) {
        debugLog('[JWT] Token initialization completed successfully');
        debugLog('[JWT] Token will be used for API requests');

        // Opportunistic device-geo re-capture: gated on a minted token
        // because the POST is JWT-authed and ApiClient does not fetch a
        // missing token itself. Running without one would claim the throttle
        // window for a capture that can only 401. No-ops unless the layout
        // opted in and the geolocation permission is already granted.
        // Fire-and-forget.
        maybeCaptureGeoObservation();
      } else {
        if (JWT_DEBUG) {
          console.warn('[JWT] Token initialization completed but no token was obtained');
        }
      }
    } else {
      debugLog('[JWT] User is not logged in, skipping token initialization');
    }
  } catch (error) {
    console.error('[JWT] Error in token initializer script:', error);
  }
  debugLog('[JWT] Token initializer script finished execution');
});
